<template>
    <section class="o-page-bottom-spacing">
        <page-header>
            <slot slot="title">{{ $t('banner.page_header_edit') }}</slot>
        </page-header>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">

                <div class="u-max-700 c-form-row">
                    <v-loading :data="loaded" type="global"></v-loading>

                    <v-form-row>
                        <v-input v-model="Banner.Name" name="banner_name" :fluid="true" :error="Validate.Title">
                            <slot slot="label">{{ $t('banner.label.name') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                            <div class="c-form-item c-form-item--horizontal c-form-item--fluid">
                                <label class="c-label">{{ $t('banner.label.image') }}</label>
                                <div class="u-inline-block u-pos-relative" style="width: 1170px">
                                    <v-picture-input
                                            :width="1170"
                                            :height="150"
                                            :selected="Banner.Image"
                                            @changed="setBanner">
                                    </v-picture-input>
                                </div>
                            </div>
                        </v-form-row>

                    <v-form-row>
                        <v-input v-model="Banner.Hyperlink" name="banner_hyperlink" :fluid="true" :error="Validate.Title" placeholder="http://">
                            <slot slot="label">{{ $t('banner.label.hyperlink') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="Banner.CTAText" name="banner_cta" :fluid="true" :error="Validate.Title">
                            <slot slot="label">{{ $t('banner.label.call_to_action') }}</slot>
                        </v-input>
                    </v-form-row>
                    
                    <v-form-row>
                        <v-datepicker v-model="Banner.StartDate"
                                      :available-dates="{ start: null, end: null }"
                                      :label="$t('banner.label.start_date')"
                                      :error="Validate.StartDate"
                                      :fluid="true"></v-datepicker>
                    </v-form-row>

                    <v-form-row>
                        <v-datepicker v-model="Banner.EndDate"
                                      :available-dates="{ start: null, end: null }"
                                      :label="$t('banner.label.end_date')"
                                      :error="Validate.EndDate"
                                      :fluid="true"></v-datepicker>
                    </v-form-row>

                    <v-form-row>
                        <v-custom-select v-model="Banner.Branches"
                                         :options="BranchOptions"
                                         option-name="Name"
                                         option-value="Id"
                                         :error="Validate.Branches"
                                         name="branch"
                                         search-label="Name"
                                         track-by="Id"
                                         :fluid="true" 
                                         :multiple="true">
                            <slot slot="label">{{ $t('banner.label.branches') }}</slot>
                        </v-custom-select>
                    </v-form-row>

                    <v-form-row>
                        <v-custom-select v-model="Banner.Locations"
                                         :options="BannerLocations"
                                         option-name="content"
                                         option-value="Type"
                                         :error="Validate.Locations"
                                         name="content"
                                         search-label="content"
                                         track-by="Type"
                                         :fluid="true"
                                         :multiple="true">
                            <slot slot="label">{{ $t('banner.label.locations') }}</slot>
                        </v-custom-select>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model.number="Banner.Weight" name="weight" type="number" :error="Validate.Weight">
                            <slot slot="label">{{ $t('banner.label.weight') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal">
                            <v-label></v-label>
                            <button @click="submitForm" class="c-button c-button--alpha">{{ $t('banner.button.edit') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import VLoading from '@/components/Loading'
    import PageHeader from '@/components/common/PageHeader'

    // Forms
    import VTextarea from '@/components/form/Textarea'
    import VPictureInput from '@/components/form/PictureInput'
    import VInput from '@/components/form/Input'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VDatepicker from '@/components/form/Datepicker'
    import VTargetListSelect from '@/components/form/targetList/TargetListSelect'
    import VSwitch from '@/components/form/Switch'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VLoading,
            PageHeader,
            VTextarea,
            VSelect,
            VCustomSelect,
            VLabel,
            VInput,
            VFormRow,
            VDatepicker,
            VTargetListSelect,
            VSwitch,
            VPictureInput
        },
        data() {
            return {
                Validate: {},
                loaded: {}
            }
        },
        computed: {
            ...mapGetters({
                BranchOptions: 'BranchOptions',
                BannerLocations: 'BannerLocations',
                Banner: 'Banner'
            }),
        },
        created: function () {
            this.$store.dispatch('getBranchOptions');
            this.$store.dispatch('getBanner', this.$attrs.id).then(() => {
                this.loaded = { isLoaded: true }
            });
        },
        methods: {
            validateForm(response){
                let errors = response.data.ModelState;

                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });

                this.Validate = errors;
            },
            submitForm(e) {
                this.loaded = {}
                this.$store.dispatch('updateBanner', this.Banner).then((response) => {
                    if (response.status > 300) {
                        this.validateForm(response);
                    } else {
                        this.$router.push({
                            name: 'BannerOverview'
                        });
                    }
                    this.loaded = { isLoaded: true }
                }).catch(() => {
                    this.loaded = { isLoaded: true };
                });
                e.preventDefault();
            },
            setBanner(picture) {
                this.$set(this.Banner, 'Image', picture)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/admin/banners/Edit.vue